import { normalize } from "common/lib/normalize";
import { getAgencies } from "common/services/agencies.service";
import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { FormFeedback, Label } from "reactstrap";

const SelectAgency = ({
  validation,
  label,
}: {
  validation: any;
  label?: any;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.agency && validation.errors.agency
          ? "red"
          : "#ced4da", // styles.borderColor,
      borderRadius: ".25rem",
      "&:hover": {
        borderColor:
          validation.touched.agency && validation.errors.agency
            ? "red"
            : "#ced4da", // styles["&:hover"].borderColor,
        borderRadius: ".25rem",
      },
    }),
  };


  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getAgencies({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
          filters: {
            category: {
              $null: false,
            },
          },
          sort: ["name"],
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <>
      <Label htmlFor="agency-field" className="form-label">
        {label ? label : "Reporting Agency"}
      </Label>
      <Select
        // isDisabled={isAgencyDisabled}
        isClearable
        name="agency"
        id="agency"
        value={
          validation.values?.agency?.value ? validation.values.agency : null
        }
        placeholder="Select reporting agency"
        onChange={(value: any) => {
          validation.setFieldValue("agency", value);
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("agency", true)}
        className={
          validation.touched.agency && validation.errors.agency
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        loading={loading}
      />
      <FormFeedback>{validation.errors.agency?.value}</FormFeedback>
    </>
  );
};

export default SelectAgency;
